import Vue from "vue";
import Overlay from "./overlay.vue";
import { selectorOverlayMount, selectorImageOverlayItem, selectorSlideshowOverlayMount, selectorSlideshowImageOverlayItem } from './selectors.js';

window.addEventListener("DOMContentLoaded", () => {
  mountOverlayComponent();
});

const mountOverlayComponent = () => {
  const overlayMount = document.querySelector(selectorOverlayMount);
  const slideshowOverlayMount = document.querySelector(selectorSlideshowOverlayMount);

  const allImageTriggerEls = Array.from(document.querySelectorAll(selectorImageOverlayItem) ?? []);
  const slideshowTriggerEls = Array.from(document.querySelectorAll(selectorSlideshowImageOverlayItem) ?? []);

  // Exclude slideshow elements from the non-slideshow overlay elements
  const triggerEls = allImageTriggerEls.filter(el => !slideshowTriggerEls.includes(el) ?? []);

  const carouselContext = Vue.observable({
    index: 0,
    itemCount: triggerEls.length,
    isOverlayOpen: false
  });

  // Exclude the thumbnail image from the slideshow
  const slideshowDisplayTriggerEls = slideshowTriggerEls.slice(1);
  const slideshowCarouselContext = Vue.observable({
    index: 0,
    itemCount: slideshowDisplayTriggerEls.length,
    isOverlayOpen: false
  });

  const onIndexChanged = index => carouselContext.index = index || 0;

  const onSlideshowIndexChanged = index => slideshowCarouselContext.index = index || 0;

  const openOverlayAtIndex = index =>
    Object.assign(carouselContext, { index, isOverlayOpen: true });

  const openSlideshowOverlayAtIndex = index => {
    Object.assign(slideshowCarouselContext, { 
      index: Math.max(0, index - 1), // Adjust index to account for thumbnail exclusion
      isOverlayOpen: true 
    });
  }

  triggerEls.forEach((el, index) =>
    el.addEventListener('click', openOverlayAtIndex.bind(this, index)));

  slideshowTriggerEls.forEach((el, index) =>
    el.addEventListener('click', openSlideshowOverlayAtIndex.bind(this, index)));

  if (overlayMount && triggerEls.length) {
    new Vue({
      el: overlayMount,
      components: { Overlay },
      data() {
        return {
          triggerEls,
          carouselContext
        };
      },
      methods: { 
        onIndexChanged 
      },
      template: `
        <Overlay
          :triggerEls="triggerEls"
          :carouselContext="carouselContext"
          mountDataAttribute="data-overlay-vue-container"
          @indexChanged="onIndexChanged"
        />
      `
    });
  }

  if (slideshowOverlayMount && slideshowTriggerEls.length) {
    new Vue({
      el: slideshowOverlayMount,
      components: { Overlay },
      data() {
        return {
          triggerEls: slideshowDisplayTriggerEls,
          carouselContext: slideshowCarouselContext
        };
      },
      methods: {
        onSlideshowIndexChanged
      },
      template: `
        <Overlay
          :triggerEls="triggerEls"
          :carouselContext="carouselContext"
          mountDataAttribute="data-overlay-slideshow-vue-container"
          @indexChanged="onSlideshowIndexChanged"
        />
      `
    });
  }
}

export default mountOverlayComponent;
